import { render, staticRenderFns } from "./IdiomRecomItem.vue?vue&type=template&id=041bfe00&scoped=true&"
import script from "./IdiomRecomItem.vue?vue&type=script&lang=js&"
export * from "./IdiomRecomItem.vue?vue&type=script&lang=js&"
import style0 from "./IdiomRecomItem.vue?vue&type=style&index=0&id=041bfe00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041bfe00",
  null
  
)

export default component.exports